/* */ 
"use strict";
var lang_1 = require('../facade/lang');
var collection_1 = require('../facade/collection');
var view_type_1 = require('./view_type');
var StaticNodeDebugInfo = (function() {
  function StaticNodeDebugInfo(providerTokens, componentToken, refTokens) {
    this.providerTokens = providerTokens;
    this.componentToken = componentToken;
    this.refTokens = refTokens;
  }
  return StaticNodeDebugInfo;
}());
exports.StaticNodeDebugInfo = StaticNodeDebugInfo;
var DebugContext = (function() {
  function DebugContext(_view, _nodeIndex, _tplRow, _tplCol) {
    this._view = _view;
    this._nodeIndex = _nodeIndex;
    this._tplRow = _tplRow;
    this._tplCol = _tplCol;
  }
  Object.defineProperty(DebugContext.prototype, "_staticNodeInfo", {
    get: function() {
      return lang_1.isPresent(this._nodeIndex) ? this._view.staticNodeDebugInfos[this._nodeIndex] : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DebugContext.prototype, "context", {
    get: function() {
      return this._view.context;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DebugContext.prototype, "component", {
    get: function() {
      var staticNodeInfo = this._staticNodeInfo;
      if (lang_1.isPresent(staticNodeInfo) && lang_1.isPresent(staticNodeInfo.componentToken)) {
        return this.injector.get(staticNodeInfo.componentToken);
      }
      return null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DebugContext.prototype, "componentRenderElement", {
    get: function() {
      var componentView = this._view;
      while (lang_1.isPresent(componentView.declarationAppElement) && componentView.type !== view_type_1.ViewType.COMPONENT) {
        componentView = componentView.declarationAppElement.parentView;
      }
      return lang_1.isPresent(componentView.declarationAppElement) ? componentView.declarationAppElement.nativeElement : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DebugContext.prototype, "injector", {
    get: function() {
      return this._view.injector(this._nodeIndex);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DebugContext.prototype, "renderNode", {
    get: function() {
      if (lang_1.isPresent(this._nodeIndex) && lang_1.isPresent(this._view.allNodes)) {
        return this._view.allNodes[this._nodeIndex];
      } else {
        return null;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DebugContext.prototype, "providerTokens", {
    get: function() {
      var staticNodeInfo = this._staticNodeInfo;
      return lang_1.isPresent(staticNodeInfo) ? staticNodeInfo.providerTokens : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DebugContext.prototype, "source", {
    get: function() {
      return this._view.componentType.templateUrl + ":" + this._tplRow + ":" + this._tplCol;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DebugContext.prototype, "references", {
    get: function() {
      var _this = this;
      var varValues = {};
      var staticNodeInfo = this._staticNodeInfo;
      if (lang_1.isPresent(staticNodeInfo)) {
        var refs = staticNodeInfo.refTokens;
        collection_1.StringMapWrapper.forEach(refs, function(refToken, refName) {
          var varValue;
          if (lang_1.isBlank(refToken)) {
            varValue = lang_1.isPresent(_this._view.allNodes) ? _this._view.allNodes[_this._nodeIndex] : null;
          } else {
            varValue = _this._view.injectorGet(refToken, _this._nodeIndex, null);
          }
          varValues[refName] = varValue;
        });
      }
      return varValues;
    },
    enumerable: true,
    configurable: true
  });
  return DebugContext;
}());
exports.DebugContext = DebugContext;
